import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'
import $ from 'jquery'
import { useEffect } from 'react'

export default function useProjectBranding() {
  // const partner = env.PROJECT_TYPE
  const hostname = useHostname()

  useEffect(() => {
    document.title = `${
      BaseConfig[hostname]?.name || 'VietInvoice'
    } - Giải pháp hóa đơn điện tử `
  }, [hostname])

  useEffect(() => {
    const favicons = [
      {
        ...BaseConfig[hostname]?.favicons,
      },
    ]

    // Remove existing favicons
    $('link[rel="icon"], link[rel="manifest"]').remove()

    // Create and append new favicon elements
    favicons.forEach((favicon) => {
      const link = document.createElement('link')
      link.rel = favicon.rel
      if (favicon.type) link.type = favicon.type
      link.href = favicon.href
      document.head.appendChild(link)
    })
  }, [hostname])

  return {
    logo: BaseConfig[hostname]?.logo,
    secondLogo: BaseConfig[hostname]?.secondLogo,
  }
}
